module.exports = __webpack_public_path__ + "media/p_bpair_win.c77e757e.mp3";